import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon, HeartPulseIcon, ChevronDownIcon } from 'lucide-react';
export function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);
  return <>
      {/* Top Utility Bar */}
      <div className="bg-gray-100 text-text-muted text-center py-1.5 px-4 border-b border-gray-200" data-id="element-227">
        <p className="text-[11px] font-semibold tracking-wide uppercase" data-id="element-228">
          Licensed THA Agency # 12345678&nbsp;&nbsp;|&nbsp;&nbsp;WSIB
          Insured&nbsp;&nbsp;|&nbsp;&nbsp;Nurse-Owned &amp; Operated
        </p>
      </div>

      {/* Announcement bar */}
      <div className="bg-accent-teal text-white text-center text-xs font-medium py-2 px-4 tracking-wide" data-id="element-229">
        🇨🇦 Proudly Canadian &amp; Nurse-Owned — Serving Ontario, BC &amp;
        Alberta
      </div>

      {/* Main nav */}
      <nav className={`sticky top-0 z-50 w-full transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-card border-b border-gray-100' : 'bg-white border-b border-gray-100'}`} role="navigation" aria-label="Main navigation" data-id="element-230">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-231">
          <div className="flex items-center justify-between h-16" data-id="element-232">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2.5 group" aria-label="Care Nomads Home" data-id="element-233">
              <img src="https://cdn.magicpatterns.com/uploads/pi4C6Ke6dQudbV1eBciptk/Media_(1).jpg" alt="Care Nomads" className="h-10 w-auto object-contain" data-id="element-234" />
            </Link>

            {/* Desktop nav links */}
            <div className="hidden md:flex items-center gap-1" data-id="element-235">
              <Link to="/" className="px-3.5 py-2 text-sm font-medium text-text-dark hover:text-medical-blue rounded-lg hover:bg-soft-teal transition-all" data-id="element-236">
                Home
              </Link>
              <div className="relative group" data-id="element-237">
                <button className="flex items-center gap-1 px-3.5 py-2 text-sm font-medium text-text-dark hover:text-medical-blue rounded-lg hover:bg-soft-teal transition-all" data-id="element-238">
                  Services{' '}
                  <ChevronDownIcon className="w-3.5 h-3.5 opacity-60" data-id="element-239" />
                </button>
                <div className="absolute top-full left-0 mt-1 w-56 bg-white rounded-xl shadow-float border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50" data-id="element-240">
                  <div className="p-2" data-id="element-241">
                    <Link to="/services/tha" className="block px-3 py-2 text-sm text-text-dark hover:bg-soft-teal hover:text-medical-blue rounded-lg transition-colors" data-id="element-242">
                      Temporary Healthcare Aides
                    </Link>
                    <Link to="/services/rn" className="block px-3 py-2 text-sm text-text-dark hover:bg-soft-teal hover:text-medical-blue rounded-lg transition-colors" data-id="element-243">
                      Registered Nurses (RN)
                    </Link>
                    <Link to="/services/rpn" className="block px-3 py-2 text-sm text-text-dark hover:bg-soft-teal hover:text-medical-blue rounded-lg transition-colors" data-id="element-244">
                      Registered Practical Nurses
                    </Link>
                    <Link to="/services/psw" className="block px-3 py-2 text-sm text-text-dark hover:bg-soft-teal hover:text-medical-blue rounded-lg transition-colors" data-id="element-245">
                      Personal Support Workers
                    </Link>
                    <div className="border-t border-gray-100 my-1" data-id="element-246" />
                    <Link to="/services/in-home-nursing" className="block px-3 py-2 text-sm text-text-dark hover:bg-soft-teal hover:text-medical-blue rounded-lg transition-colors" data-id="element-247">
                      In-Home Nursing
                    </Link>
                    <Link to="/services/dementia-care" className="block px-3 py-2 text-sm text-text-dark hover:bg-soft-teal hover:text-medical-blue rounded-lg transition-colors" data-id="element-248">
                      Dementia Care
                    </Link>
                    <Link to="/services/personal-care" className="block px-3 py-2 text-sm text-text-dark hover:bg-soft-teal hover:text-medical-blue rounded-lg transition-colors" data-id="element-249">
                      Personal Care Services
                    </Link>
                  </div>
                </div>
              </div>
              <Link to="/why-us" className="px-3.5 py-2 text-sm font-medium text-text-dark hover:text-medical-blue rounded-lg hover:bg-soft-teal transition-all" data-id="element-250">
                Why Us
              </Link>
              <Link to="/blog" className="px-3.5 py-2 text-sm font-medium text-text-dark hover:text-medical-blue rounded-lg hover:bg-soft-teal transition-all" data-id="element-251">
                Blog
              </Link>
              <Link to="/faq" className="px-3.5 py-2 text-sm font-medium text-text-dark hover:text-medical-blue rounded-lg hover:bg-soft-teal transition-all" data-id="element-252">
                FAQ
              </Link>
              <Link to="/contact" className="px-3.5 py-2 text-sm font-medium text-text-dark hover:text-medical-blue rounded-lg hover:bg-soft-teal transition-all" data-id="element-253">
                Contact
              </Link>
            </div>

            {/* Desktop CTAs */}
            <div className="hidden md:flex items-center gap-3" data-id="element-254">
              <a href="#" className="text-sm font-semibold text-medical-blue hover:text-medical-blue-dark transition-colors" data-id="element-255">
                Log In
              </a>
              <a href="#hero" className="bg-medical-blue hover:bg-medical-blue-dark text-white text-sm font-semibold px-5 py-2.5 rounded-xl transition-all shadow-sm hover:shadow-md" data-id="element-256">
                Find Staff Now
              </a>
            </div>

            {/* Mobile menu button */}
            <button className="md:hidden p-2 rounded-lg text-text-dark hover:bg-soft-teal transition-colors" onClick={() => setMenuOpen(true)} aria-label="Open menu" aria-expanded={menuOpen} data-id="element-257">
              <MenuIcon className="w-6 h-6" data-id="element-258" />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile slide-in menu overlay */}
      {menuOpen && <div className="fixed inset-0 z-[100] flex" role="dialog" aria-modal="true" aria-label="Mobile navigation menu" data-id="element-259">
          <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={() => setMenuOpen(false)} data-id="element-260" />
          <div className="relative w-80 max-w-[85vw] h-full bg-white shadow-2xl flex flex-col" style={{
        animation: 'slideInLeft 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards'
      }} data-id="element-261">
            <div className="flex items-center justify-between p-5 border-b border-gray-100" data-id="element-262">
              <Link to="/" className="flex items-center gap-2" onClick={() => setMenuOpen(false)} data-id="element-263">
                <img src="https://cdn.magicpatterns.com/uploads/pi4C6Ke6dQudbV1eBciptk/Media_(1).jpg" alt="Care Nomads" className="h-8 w-auto object-contain" data-id="element-264" />
              </Link>
              <button onClick={() => setMenuOpen(false)} className="p-2 rounded-lg hover:bg-soft-teal transition-colors" aria-label="Close menu" data-id="element-265">
                <XIcon className="w-5 h-5 text-text-muted" data-id="element-266" />
              </button>
            </div>

            <nav className="flex-1 p-4 space-y-1 overflow-y-auto" data-id="element-267">
              <Link to="/" className="flex items-center gap-3 px-4 py-3 rounded-xl text-text-dark font-medium hover:bg-soft-teal hover:text-medical-blue transition-all" onClick={() => setMenuOpen(false)} data-id="element-268">
                🏠 Home
              </Link>
              <div className="px-4 py-2" data-id="element-269">
                <div className="text-xs font-semibold text-text-muted uppercase tracking-widest mb-2" data-id="element-270">
                  Services (THA)
                </div>
                <div className="space-y-1 pl-2" data-id="element-271">
                  <Link to="/services/tha" className="block px-3 py-2 text-sm text-text-dark hover:text-medical-blue hover:bg-soft-teal rounded-lg transition-all" onClick={() => setMenuOpen(false)} data-id="element-272">
                    Temporary Healthcare Aides
                  </Link>
                  <Link to="/services/rn" className="block px-3 py-2 text-sm text-text-dark hover:text-medical-blue hover:bg-soft-teal rounded-lg transition-all" onClick={() => setMenuOpen(false)} data-id="element-273">
                    Registered Nurses (RN)
                  </Link>
                  <Link to="/services/psw" className="block px-3 py-2 text-sm text-text-dark hover:text-medical-blue hover:bg-soft-teal rounded-lg transition-all" onClick={() => setMenuOpen(false)} data-id="element-274">
                    Personal Support Workers
                  </Link>
                </div>
              </div>
              <div className="px-4 py-2" data-id="element-275">
                <div className="text-xs font-semibold text-text-muted uppercase tracking-widest mb-2" data-id="element-276">
                  Care Solutions
                </div>
                <div className="space-y-1 pl-2" data-id="element-277">
                  <Link to="/services/in-home-nursing" className="block px-3 py-2 text-sm text-text-dark hover:text-medical-blue hover:bg-soft-teal rounded-lg transition-all" onClick={() => setMenuOpen(false)} data-id="element-278">
                    In-Home Nursing
                  </Link>
                  <Link to="/services/dementia-care" className="block px-3 py-2 text-sm text-text-dark hover:text-medical-blue hover:bg-soft-teal rounded-lg transition-all" onClick={() => setMenuOpen(false)} data-id="element-279">
                    Dementia Care
                  </Link>
                  <Link to="/services/personal-care" className="block px-3 py-2 text-sm text-text-dark hover:text-medical-blue hover:bg-soft-teal rounded-lg transition-all" onClick={() => setMenuOpen(false)} data-id="element-280">
                    Personal Care Services
                  </Link>
                </div>
              </div>
              <Link to="/why-us" className="flex items-center gap-3 px-4 py-3 rounded-xl text-text-dark font-medium hover:bg-soft-teal hover:text-medical-blue transition-all" onClick={() => setMenuOpen(false)} data-id="element-281">
                ⭐ Why Us (Nurse-Led)
              </Link>
              <Link to="/blog" className="flex items-center gap-3 px-4 py-3 rounded-xl text-text-dark font-medium hover:bg-soft-teal hover:text-medical-blue transition-all" onClick={() => setMenuOpen(false)} data-id="element-282">
                📝 Blog
              </Link>
              <Link to="/faq" className="flex items-center gap-3 px-4 py-3 rounded-xl text-text-dark font-medium hover:bg-soft-teal hover:text-medical-blue transition-all" onClick={() => setMenuOpen(false)} data-id="element-283">
                ❓ FAQ
              </Link>
              <Link to="/contact" className="flex items-center gap-3 px-4 py-3 rounded-xl text-text-dark font-medium hover:bg-soft-teal hover:text-medical-blue transition-all" onClick={() => setMenuOpen(false)} data-id="element-284">
                📞 Contact Us
              </Link>
            </nav>

            <div className="p-4 border-t border-gray-100 space-y-3" data-id="element-285">
              <a href="#" className="block w-full text-center bg-medical-blue text-white font-semibold py-3 rounded-xl hover:bg-medical-blue-dark transition-colors" onClick={() => setMenuOpen(false)} data-id="element-286">
                Find Staff Now
              </a>
              <a href="#" className="block w-full text-center bg-accent-teal text-white font-semibold py-3 rounded-xl hover:opacity-90 transition-colors" onClick={() => setMenuOpen(false)} data-id="element-287">
                Caregiver Signup
              </a>
              <a href="#" className="block w-full text-center border-2 border-medical-blue text-medical-blue font-semibold py-3 rounded-xl hover:bg-soft-teal transition-colors" onClick={() => setMenuOpen(false)} data-id="element-288">
                Log In
              </a>
            </div>
          </div>
        </div>}

      <style data-id="element-289">{`
        @keyframes slideInLeft {
          from { transform: translateX(-100%); }
          to { transform: translateX(0); }
        }
      `}</style>
    </>;
}